import React, { useEffect, useState } from "react";
import querystring from "querystring";
import Media from "react-media";
import Loading from "../../components/Assets/Loading.js";
import EquipmentTable from "../../components/equipment/EquipmentTable";
import EquipmentMobileList from "../../components/equipment/EquipmentMobileList";
import EquipmentForm from "../../components/equipment/EquipmentForm";
import { Pagination } from "antd";
import { Swipeable } from "react-swipeable";

const Equipment = (props) => {
  const {
    redux,
    history,
    fetchBranchRegions,
    fetchCategories,
    fetchSubCategories,
    fetchEquipmentForm,
    fetchConditions,
    setEquipmentDetails,
    setEquipmentFetchID,
    timestamp,
  } = props;

  const {
    loading,
    statusFilterOptions,
    categoryList,
    branchList,
    contentLoader,
    branchRegions,
    equipmentList,
    equipmentLoader,
    equipmentTotal,
    subCategoryLoader,
    subCategoryList,
    conditions,
    branchListLoader,
    wildcardFilter,
  } = redux;

  const {
    branchID: urlBranchID,
    branchCode: urlBranchCode,
    search: urlSearch,
    status: urlStatus,
    selectedRegion: urlRegion,
    category: urlCategory,
    catType: urlCatType,
    page: urlPage,
    pageLength: urlPageLength,
    subCategory: urlSubCategory,
    exclude: urlExclude,
    catCode: urlCatCode,
    sort: urlSort,
    sortDir: urlSortDir,
  } = querystring.parse(window.location.search.substring(1));

  const [branchID, setBranchID] = useState(urlBranchID);
  const [branchCode, setBranchCode] = useState(urlBranchCode);
  const [stateSelectedRegion, setStateSelectedRegion] = useState(
    urlRegion || "All"
  );
  const [stateSearch, setStateSearch] = useState(urlSearch || "");
  const [stateStatus, setStateStatus] = useState(Number(urlStatus || "1"));
  const [stateCategory, setStateCategory] = useState(
    urlCategory
      ? Array.isArray(urlCategory)
        ? urlCategory
        : [urlCategory] || ["All"]
      : ["All"]
  ); // urlCategory ||
  const [stateCatType, setCatType] = useState(urlCatType || "");
  const [statePage, setStatePage] = useState(Number(urlPage) || 1);
  const [statePageLength, setStatePageLength] = useState(
    Number(urlPageLength) || 10
  );
  const [stateSubCategory, setStateSubCategory] = useState(
    urlSubCategory || ""
  );
  const [stateCatCode, setStateCatCode] = useState(urlCatCode);
  const [stateExclude, setStateExclude] = useState(
    urlExclude ? JSON.parse(urlExclude) : true
  );
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [stateFetchID, setStateFetchID] = useState(0);
  const [stateSort, setStateSort] = useState(urlSort || "rank");
  const [stateSortDir, setStateSortDir] = useState(urlSortDir || "Desc");
  const [renderCount, setRenderCount] = useState(0);
  useEffect(() => {
    setEquipmentFetchID(stateFetchID);
  }, [stateFetchID, setEquipmentFetchID]);

  useEffect(() => {
    if (categoryList.length < 1) {
      fetchCategories();
    }
    if (conditions) {
      fetchConditions();
    }
    if (branchList.length < 1) {
      fetchBranchRegions();
    }
    if (subCategoryList.length < 1) {
      fetchSubCategories();
    }
  }, []);

  useEffect(() => {
    handleTableURLChanges(statePage, statePageLength, stateSortDir, stateSort);
  }, [statePage, statePageLength, stateSortDir, stateSort]);

  const [locationTreeValues, setLocationTreeValues] = useState([]);
  const [categoryTreeValues, setCategoryTreeValues] = useState([]);

  const locationTreeBuilder = () => {
    const values = branchRegions.map((region, regionIndex) => {
      return {
        value: region,
        title: region,
        region: true,
        key: regionIndex,
        children:
          branchList.filter(
            (branch) => branch.regionCode === region && branch.isMain
          ).length > 0
            ? branchList
                .filter(
                  (branch) => branch.regionCode === region && branch.isMain
                )
                .map((mainBranch, mainBranchIndex) => {
                  return {
                    id: mainBranch.id,
                    code: mainBranch.code,
                    key: `${regionIndex}-${mainBranchIndex}`,
                    value: `${mainBranch.code} ${mainBranch.description}`,
                    description: mainBranch.description,
                    title: `${mainBranch.code} ${mainBranch.description}`,
                    children: branchList
                      .filter(
                        (branch) =>
                          branch.regionCode === region &&
                          !branch.isMain &&
                          branch.code === mainBranch.code &&
                          mainBranch.country === branch.country
                      )
                      .map((branch, branchIndex) => {
                        return {
                          isLeaf: true,
                          id: branch.id,
                          code: branch.code,
                          key: `${regionIndex}-${mainBranchIndex}-${branchIndex}`,
                          value: `${branch.code} ${branch.description}`,
                          title: `${branch.code} ${branch.description}`,
                          description: branch.description,
                        };
                      }),
                  };
                })
            : branchList
                .filter(
                  (branch) => branch.regionCode === region && !branch.isMain
                )
                .map((branch, branchIndex) => {
                  return {
                    isLeaf: true,
                    id: branch.id,
                    code: branch.code,
                    key: `${regionIndex}-nonmain-${branchIndex}`,
                    value: `${branch.code} ${branch.description}`,
                    title: `${branch.code} ${branch.description}`,
                    description: branch.description,
                  };
                }),
      };
    });
    values.unshift({
      value: "All",
      description: "All",
      title: "All",
      key: "All",
    });
    return values;
  };

  const categoryTreeBuilder = () => {
    const treeData = categoryList.map((category, categoryIndex) => {
      return {
        value: `{ "value": "${category}", "subCategory": true}`,
        title: category,
        key: categoryIndex,
        subCategory: true,
        children: subCategoryList
          .filter((subCategory) => subCategory.catCode === category)
          .map((subCategory, subCategoryIndex) => {
            return {
              isLeaf: true,
              catType: subCategory.catType,
              cat: subCategory.type,
              catCode: subCategory.catCode,
              key: `${categoryIndex}-${subCategoryIndex}`,
              value: `{"cat": "${subCategory.type}", "catType": "${subCategory.catType}", "catCode": "${subCategory.catCode}"}`,
              title: `${subCategory.type} ${subCategory.catType}`,
            };
          }),
      };
    });
    treeData.unshift({
      value: `All`,
      description: "All",
      title: "All",
      key: "All",
    });
    return treeData;
  };

  useEffect(() => {
    if (!subCategoryLoader && categoryList.length > 0) {
      const values = categoryTreeBuilder();
      setCategoryTreeValues(values);
    }
  }, [categoryList, subCategoryLoader]);

  useEffect(() => {
    if (!branchListLoader && branchRegions) {
      const values = locationTreeBuilder();
      setLocationTreeValues(values);
    }
  }, [branchRegions]);

  const getOperands = () => {
    const operands = [];
    if (branchID) {
      operands.push({
        Field: "fleetBranchId",
        FilterType: "Equal",
        Value: branchID,
      });
      operands.push({
        Field: "branchCode",
        FilterType: "startsWith",
        Value: branchCode,
      });
    } else if (stateSelectedRegion && stateSelectedRegion !== "All") {
      operands.push({
        Field: "regionCode",
        FilterType: "Equal",
        Value: stateSelectedRegion,
      });
    }
    if (stateStatus !== 0) {
      operands.push({
        Field: "Status",
        FilterType: "Equal",
        Value: stateStatus,
      });
    }

    if (stateCategory[0] && stateCategory[0] !== "All") {
      operands.push({
        Field: "type",
        FilterType: "Equal",
        Value: stateCategory,
      });
    } else if (stateSubCategory && stateSubCategory !== "All") {
      operands.push({
        Field: "catCode",
        FilterType: "Equal",
        Value: stateSubCategory,
      });
    }
    if (stateSearch.trim() !== "") {
      operands.push({
        Field: "fldDesc",
        FilterType: "Contains",
        Value: stateSearch,
      });
    }
    if (stateExclude) {
      operands.push({
        Field: "condition",
        FilterType: "NotEqual",
        Value: "Repair",
      });
    }
    return operands;
  };

  const buildURL = () => {
    const operands = getOperands();
    let queryParams = "";
    queryParams += `Skip=${(statePage - 1) * statePageLength || 0}`;
    queryParams += `&Take=${statePageLength || 10}`;
    queryParams += `&OrderBy[0].Field=${stateSort}`;
    queryParams += `&OrderBy[0].Order=${stateSortDir}`;
    if (operands.length > 0) {
      if (operands.length !== 0) {
        queryParams += "&Where.OperatorType=And";
      }
      operands.forEach((elem, index) => {
        switch (elem.Field) {
          case "fldDesc": {
            elem.Value.replace("&", "%26");
            elem.Value = elem.Value.replace(/[\u2018\u2019]/g, '"') // fancy coma iPhone
              .replace(/[\u201C\u201D]/g, '"') // fancy coma iPhone
              .trim();
            queryParams += `&Where.Operands[${index}].Field=fldDesc`;
            queryParams += `&Where.Operands[${index}].FilterType=Contains`;
            queryParams += `&Where.Operands[${index}].Value=${elem.Value}`;
            break;
          }
          case "type": {
            queryParams += `&Where.Operands[${index}].OperatorType=Or`;
            elem.Value.forEach((elem, i) => {
              let json = JSON.parse(elem);

              if (json.subCategory) {
                json.value = json.value.replace("&", "%26");
                queryParams += `&Where.Operands[${index}].Operands[${i}].Field=catCode`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].FilterType=Equal`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].Value=${json.value}`;
              } else {
                json.catType = json.catType.replace("&", "%26");
                json.cat = json.cat.replace("&", "%26");
                queryParams += `&Where.Operands[${index}].Operands[${i}].OperatorType=And`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].Operands[0].Field=catType`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].Operands[0].FilterType=Equal`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].Operands[0].Value=${json.catType}`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].Operands[1].Field=type`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].Operands[1].FilterType=Equal`;
                queryParams += `&Where.Operands[${index}].Operands[${i}].Operands[1].Value=${json.cat}`;
              }
            });
            break;
          }
          case "Status": {
            switch (elem.Value) {
              case 1: {
                queryParams += `&Where.Operands[${index}].Field=available`;
                queryParams += `&Where.Operands[${index}].FilterType=GreaterThan`;
                queryParams += `&Where.Operands[${index}].Value=0`;
                break;
              }
              case 2: {
                queryParams += `&Where.Operands[${index}].Field=available`;
                queryParams += `&Where.Operands[${index}].FilterType=Equal`;
                queryParams += `&Where.Operands[${index}].Value=0`;
                break;
              }
              case 3: {
                queryParams += `&Where.Operands[${index}].Field=reserved`;
                queryParams += `&Where.Operands[${index}].FilterType=GreaterThan`;
                queryParams += `&Where.Operands[${index}].Value=0`;
                break;
              }
              case 4: {
                queryParams += `&Where.Operands[${index}].Field=terminated`;
                queryParams += `&Where.Operands[${index}].FilterType=GreaterThan`;
                queryParams += `&Where.Operands[${index}].Value=0`;
                break;
              }
              default: {
                break;
              }
            }
            break;
          }
          default: {
            if (typeof stringValue === "string") {
              elem.Value.replace("&", "%26");
            }
            queryParams += `&Where.Operands[${index}].Field=${elem.Field}`;
            queryParams += `&Where.Operands[${index}].FilterType=${elem.FilterType}`;
            queryParams += `&Where.Operands[${index}].Value=${elem.Value}`;
          }
        }
      });
    }
    return queryParams;
  };

  const handleTableURLChanges = (page, pageLength, sortDir, sort) => {
    const url = querystring.parse(window.location.search.substring(1));
    if (page !== 1) {
      url.page = page;
    } else {
      delete url.page;
    }
    if (pageLength !== 10) {
      url.pageLength = pageLength;
    } else {
      delete url.pageLength;
    }
    if (sort === "rank") {
      delete url.sortDir;
      delete url.sort;
    } else {
      url.sortDir = sortDir;
      url.sort = sort;
    }
    history.push({
      search: querystring.stringify(url),
    });
  };

  const handleChangeForm = (params) => {
    const {
      search,
      status,
      category,
      catType,
      selectedRegion,
      branchID,
      stateCategory,
      branchCode,
      subCategory,
      exclude,
      catCode,
      selectedCategories,
    } = params;

    const route = {};

    if (status !== 1) route.status = status;
    if (category && category !== "All") route.category = category;
    if (catType) route.catType = catType;
    if (branchID) route.branchID = branchID;
    if (branchCode) route.branchCode = branchCode;
    if (selectedRegion && selectedRegion !== "All")
      route.selectedRegion = selectedRegion;
    if (search) route.search = search;
    if (subCategory && subCategory !== "All") route.subCategory = subCategory;
    if (!exclude) route.exclude = exclude;
    if (catCode) route.catCode = catCode;
    if (statePage !== 10) route.page = statePage;
    if (statePageLength !== 1) route.pageLength = statePageLength;
    if (selectedCategories !== "") route.category = selectedCategories;

    history.push({
      search: querystring.stringify(route),
    });
    setStateSearch(search);
    setStateStatus(status);
    setStateCategory(selectedCategories);
    setCatType(catType);
    setBranchCode(branchCode);
    setBranchID(branchID);
    setStateSelectedRegion(selectedRegion);
    if(renderCount > 1){
      setStatePage(1);
    }
    setStateSubCategory(subCategory);
    setStateExclude(exclude);
    setStateCatCode(catCode);
  };

  useEffect(() => {
    // If the user is on a page that that exceeds the number of results this
    // function brings them back to a real page
    // Ej if they select a page 8 but there is only 33 results this will take them to page 4
    let tempPage = Math.ceil(equipmentTotal / statePageLength);
    if (equipmentTotal && tempPage < statePage) {
      setStatePage(tempPage);
    }
  }, [equipmentTotal]);

  // this is kinda repeated function but only renders when we change the page length
  // so that when going from 30 to 10 dosnt nead to make another api call and just split the array
  useEffect(() => {
    if (!equipmentLoader && statePageLength > equipmentList.length) {
      fetchEquipment();
    }
  }, [statePageLength]);

  const fetchEquipment = () => {
    setRenderCount(renderCount + 1);
    const path = buildURL();
    const newFetchID = stateFetchID + 1;
    setStateFetchID(newFetchID);
    fetchEquipmentForm(path, newFetchID);
  };

  useEffect(() => {
    const interval = setTimeout(() => {
      if (Number(statePage)) fetchEquipment();
    }, 750);
    return () => {
      clearTimeout(interval);
    };
  }, [
    stateSearch,
    stateStatus,
    stateCategory,
    stateCatType,
    branchID,
    statePage,
    stateSelectedRegion,
    stateSubCategory,
    stateExclude,
    stateSortDir,
    stateSort,
  ]);

  const pagging = () => (
    <div className="paggerComponents">
      <div>
        <div
          className={statePageLength === 10 ? "notActive" : "active"}
          onClick={() => setStatePageLength(10)}
        >
          10
        </div>
        <div
          className={statePageLength === 20 ? "notActive" : "active"}
          onClick={() => setStatePageLength(20)}
        >
          20
        </div>
        <div
          className={statePageLength === 30 ? "notActive" : "active"}
          onClick={() => setStatePageLength(30)}
        >
          30
        </div>
      </div>
      <div className="pager">
        <div onClick={() => setStatePage(statePage === 1 ? 1 : statePage - 1)}>
          {"<"}
        </div>
        <div>
          <input
            style={{ width: `${`${statePage}`.length + 1}pc` }}
            value={statePage}
            onChange={(e) => {
              if (e.target.value === "e") return;
              const max = Math.ceil(equipmentTotal / statePageLength);
              const value = Number(e.target.value);
              if (value) {
                if (value > max) {
                  setStatePage(max);
                  return;
                }
                if (value <= 0) {
                  setStatePage(1);
                  return;
                }
                setStatePage(value);
              } else {
                if (e.target.value === "") {
                  setStatePage("");
                }
              }
            }}
            onKeyUp={(e) => {
              if (e.keyCode === 13) {
                if (!Number(statePage)) {
                  setStatePage(1);
                }
                e.target.blur();
              }
            }}
          />
        </div>
        <div>/</div>
        <div>{Math.ceil(equipmentTotal / statePageLength)}</div>
        <div
          onClick={() =>
            setStatePage(
              statePage === Math.ceil(equipmentTotal / statePageLength)
                ? statePage
                : statePage + 1
            )
          }
        >
          {">"}
        </div>
      </div>
    </div>
  );

  const content = () => {
    return (
      <div>
        <Swipeable
          onSwipedRight={() => {
            setToggleDrawer(false);
          }}
          onSwipedLeft={() => setToggleDrawer(true)}
        >
          <div className="ibox minHeight">
            {!contentLoader && !branchListLoader && !subCategoryLoader && (
              <EquipmentForm
                history={props.history}
                timestamp={timestamp}
                stateExclude={stateExclude}
                branchListLoader={branchListLoader}
                branchRegions={branchRegions}
                branchList={branchList}
                statusFilterOptions={statusFilterOptions}
                categoryList={categoryList}
                subCategoryList={subCategoryList}
                setParams={handleChangeForm}
                stateSelectedRegion={stateSelectedRegion}
                stateSearch={stateSearch}
                stateStatus={stateStatus}
                stateCategory={stateCategory}
                stateCatType={stateCatType}
                branchID={branchID}
                setStatePage={setStatePage}
                branchCode={branchCode}
                stateSubCategory={stateSubCategory}
                stateCatCode={stateCatCode}
                toggleDrawer={toggleDrawer}
                setToggleDrawer={setToggleDrawer}
                categoryTreeValues={categoryTreeValues}
                locationTreeValues={locationTreeValues}
                sort={stateSort}
                setStateSort={setStateSort}
                sortDir={stateSortDir}
                setStateSortDirection={setStateSortDir}
              />
            )}
            <div className="table-container">
              {pagging()}

              <div className="switchCard">
                <div className="Total">
                  {`Total Results: ${
                    equipmentLoader ? "Loading..." : equipmentTotal
                  } `}
                </div>
              </div>
              <Media query="(max-width: 720px)">
                {(matches) =>
                  matches ? (
                    <EquipmentMobileList
                      wildWords={wildcardFilter}
                      pageLength={statePageLength}
                      equipmentList={equipmentList}
                      equipmentLoader={equipmentLoader}
                      history={props.history}
                      conditions={conditions}
                    />
                  ) : (
                    <EquipmentTable
                      sort={stateSort}
                      setStateSort={setStateSort}
                      sortDir={stateSortDir}
                      setStateSortDirection={setStateSortDir}
                      wildWords={wildcardFilter}
                      setEquipmentDetails={setEquipmentDetails}
                      pageLength={statePageLength}
                      equipmentList={equipmentList}
                      equipmentLoader={equipmentLoader}
                      history={props.history}
                      stateSelectedRegion={stateSelectedRegion}
                      conditions={conditions}
                    />
                  )
                }
              </Media>
              {!equipmentLoader && equipmentList.length === 0 && (
                <div className="flexCenter">
                  <h2>No match found, please try again</h2>
                </div>
              )}
            </div>
          </div>
        </Swipeable>
      </div>
    );
  };

  return <div>{loading ? <Loading /> : content()}</div>;
};

export default Equipment;
